import { render } from "./assessementTab.vue?vue&type=template&id=30543410&scoped=true"
import script from "./assessementTab.vue?vue&type=script&lang=js"
export * from "./assessementTab.vue?vue&type=script&lang=js"

import "./assessementTab.vue?vue&type=style&index=0&id=30543410&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30543410"]])

export default __exports__